export const ACCESS_CODE_ADDED = "accessCode/added"
export const ACCESS_CREDENTIALS_UPDATED = "accessCredentials/updated"
export const ACCESS_CODE_DELETED = "accessCode/deleted"